<template>
  <div id="app">
    <div class="links" v-if="loggedIn">
      <router-link to="/home">Expert</router-link>
      |
      <router-link to="/all">All</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.links {
  margin: 10px auto 0 auto;
  a {
    font-weight: normal;
    color: #2c3e50;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-left: 10px;
    margin-right: 10px;
    &:hover {
      text-decoration: underline;
    }

    &.router-link-exact-active {
      color: #00c4a7;
    }
  }
}

.content h5 {
  font-size: 1.125em;
  margin-bottom: 0.8888em;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 14px;
  font-weight: 500;
  color: #363636;
}

.section {
  padding: 2rem 1.5rem;
}
</style>
